export class ObjectionStatementDto  {
    attachments;
    objectionExists;
    issueDate;
    remarks;
}
